import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-search-library',
  templateUrl: './search-library.component.html',
  styleUrls: ['./search-library.component.scss']
})
export class SearchLibraryComponent implements OnInit {

  @Input() block: any;
  public searchLibrary: FormControl = new FormControl();
  public document: any;

  constructor() { }

  ngOnInit(): void { }

  public search(): void {
    const paramSearch = this.searchLibrary && this.searchLibrary.value ? this.searchLibrary.value : "";
    // window.open(`https://cloud.sbn.it/opac2/IEI/LU/ricercaSemplice`, '_blank');
    window.open(`https://cloud.sbn.it/opac2/IEI/LU?search=${paramSearch}`, '_blank')
  }

}

